import { RouteObject } from "react-router-dom";
import BaseLayout from "../components/layout/BaseLayout/BaseLayout";
import HelpPage from "../pages/HelpPage/HelpPage";
import { HelpRoutes } from "./HelpRouter.types";

export const useHelpRoutes = (): RouteObject[] => {
    return [
        {
            path: HelpRoutes.HELP,
            element: (
                <BaseLayout>
                    <HelpPage />
                </BaseLayout>
            ),
        },
    ];
};
